// extracted by mini-css-extract-plugin
export default {"body":"ToDoTasks_body__NVBsy","h1":"ToDoTasks_h1__-gzDc","trivial":"ToDoTasks_trivial__TwPKg"};